export default __webpack_public_path__ + "static/media/waterIcon2.06593d81.svg";